import React, { useState } from 'react'
import { version } from '../../../../../package.json'
import getEnv from '../../../environments/getEnv'
import * as S from './styled'

const VERSIONS = [
  '2.1.12',
  '2.1.11',
  '2.1.10',
  '2.1.9',
  '2.1.8',
  '2.1.7',
  '2.1.6',
  '2.1.5',
  '2.1.4',
  '2.1.3',
  '2.1.2',
  '2.1.1',
  '2.1.0',
  '2.0.10',
  '2.0.9',
  '2.0.8',
  '2.0.7',
]

const EnvTag = () => {
  const [showDropdown, setShowDropdown] = useState(false)
  const env = getEnv()
  const tag = `v${version}`

  const getVersionURL = (ver: string) =>
    `https://storage.googleapis.com/redmind-mapping.appspot.com/release-versions/liverate-version-${ver}.pdf`

  const toggleDropdown = () => setShowDropdown(!showDropdown)

  return (
    <S.Container pointerEvents="box-none">
      {showDropdown && (
        <S.DropdownContainer>
          {VERSIONS.map((ver, i) => (
            <S.DropdownItem
              key={ver}
              onPress={() => window.open(getVersionURL(ver), '_blank')}
              style={{
                borderBottomWidth: i === VERSIONS.length - 1 ? 0 : 1,
              }}
            >
              <S.DropdownText>{`v${ver}`}</S.DropdownText>
            </S.DropdownItem>
          ))}
        </S.DropdownContainer>
      )}
      <S.TagButton onPress={toggleDropdown}>
        <S.Tag>{`${env.env.toLocaleUpperCase()} ${tag}`}</S.Tag>
      </S.TagButton>
    </S.Container>
  )
}

export default EnvTag
